export function getValue(option) {
  return option.value
}
